import { getSortFunction } from './helpers'

export function getAuthorizedConfig() {
  const jwt = localStorage.getItem('token')
  const ac = {
    authorizedLayers: [],
    authorizedModules: [],
    authorizedControls: [],
    authorizedArea: null
  }

  if (jwt && /.+\..+\..+./g.test(jwt)) {
    const JWTPayload = parseJwt(jwt)
    ac.authorizedLayers = JWTPayload && JWTPayload.layers ? JWTPayload.layers.split(';') : []
    ac.authorizedModules = JWTPayload && JWTPayload.modules ? JWTPayload.modules.split(';').map((right) => right.split('.')[0]) : []
    ac.authorizedControls = JWTPayload && JWTPayload.controls ? JWTPayload.controls.split(';').map((right) => right.split('.')[0]) : []
    if (JWTPayload.area) {
      const area = JWTPayload.area.split(';')
      ac.authorizedArea = {
        extent: area[0].split(',').map((val) => val * 1),
        minZoom: area[1] * 1,
        maxZoom: area[2] * 1
      }
    }
  }
  return ac
}

export function getAvailableConfig() {
  const config = JSON.parse(localStorage.getItem('config'))
  const layerList = config.layers.filter(l => l.privilege).reverse();
  const modulesList = Object.values(config.modules).filter(m => m.right && m.enabled).sort(getSortFunction('code'));
  const controlsList = Object.values(config.controls).filter(c => c.right && c.enabled).sort(getSortFunction('code'));
  return {
    layers: [...layerList],
    controls: [...controlsList],
    modules: [...modulesList]
  }
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return JSON.parse(window.atob(base64));
}

export function authorizedControl(control, authControls) {
  const config = JSON.parse(localStorage.getItem('config'))
  const infos = config.controls[control];
  if (infos.enabled) {
    const right = infos.right;
    return authControls.includes(right);
  }
  return false
}

export function authorizedModule(module, authModules) {
  const config = JSON.parse(localStorage.getItem('config'))
  const infos = config.modules[module];
  if (infos?.enabled) {
    const right = infos.right;
    if (!right) return true;
    return authModules.includes(right)
  }
  if (/.*_management/.test(module)) return authModules.includes(module)
  return false
}

export function getModuleRightLevel(right) {
  const jwt = localStorage.getItem('token')
  if (!(jwt && /.+\..+\..+./g.test(jwt))) return null
  const JWTPayload = parseJwt(jwt)
  const modules = JWTPayload && JWTPayload.modules ? JWTPayload.modules.split(';') : [];
  const moduleRight = modules.find(m => m.split('.')[0] === right)
  return moduleRight.split('.')[1]
}